import React, { useState, useCallback } from "react";
import { useAuth } from "react-oidc-context";
import config from "constants/config";
import isEmail from "validator/lib/isEmail";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import LoginFooter from "components/common/LoginFooter";
import "./i18n";
import "./styles/bootstrap.overides.scss";
const EmailEnter = () => {
  const auth = useAuth();
  const [enteredEmail, setEnteredEmail] = useState<string>("");
  const [invalidEmail, setInvalidEmail] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getHostUrl = useCallback(
    () => `${config.scheme}://${config.host === "admin_ui_1" ? `${config.host}:${config.port}` : config.host}`,
    [],
  );

  const getIdp = useCallback(async (email) => {
    const url = config.ADMIN.apiHost + "/api/emailcheck";
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(email),
      });
      return await response.text();
    } catch (e) {
      return null;
    }
  }, []);

  const submit = useCallback(async () => {
    if (!enteredEmail || !isEmail(enteredEmail)) {
      setInvalidEmail(true);
      return;
    }
    setIsLoading(true);
    setInvalidEmail(false);
    try {
      const idpProvider = await getIdp(enteredEmail);
      const loginOptions = {
        extraQueryParams: idpProvider
          ? { kc_idp_hint: idpProvider, login_hint: enteredEmail }
          : { login_hint: enteredEmail },
      };
      await auth.signinRedirect(loginOptions);
    } catch (e) {
      setIsLoading(false);
    }
  }, [enteredEmail, getIdp, auth]);

  const handleSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  return (
    <div className="email-enter-wrapper d-flex flex-column min-vh-100">
      <header className="py-3 bg-white" style={{ borderBottom: "1px solid #ff0000" }}>
        <Container>
          <Row className="justify-content-center">
            <Col xs="auto" className="text-center">
              <a href={getHostUrl()} className="d-inline-flex align-items-center text-decoration-none">
                <span className="logo" />
              </a>
            </Col>
          </Row>
        </Container>
      </header>

      <Container className="flex-grow-1 d-flex flex-column justify-content-start py-4">
        <Row className="justify-content-center">
          <Col xs={12} md={5} lg={4}>
            <h1 className="mb-4">QJumpers Sourcing and Recruitment Software Login</h1>
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  value={enteredEmail}
                  //placeholder="name@company.com"
                  disabled={isLoading}
                  isInvalid={invalidEmail}
                  onChange={(e) => {
                    const v = e.target.value.replace(/\s/g, '');
                    setEnteredEmail(v);
                    if (invalidEmail && isEmail(v)) {
                      setInvalidEmail(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      submit();
                    }
                  }}
                  autoComplete="off"
                  autoFocus
                />
                <Form.Control.Feedback type="invalid">Invalid email.</Form.Control.Feedback>
              </Form.Group>

              <div className="text-center mt-4">
                <Button variant="success" size="lg" type="submit" disabled={isLoading}>
                  {isLoading && <Spinner as="span" animation="border" size="sm" role="status" className="me-2" />}
                  {isLoading ? "Signing in..." : "Next"}
                </Button>
              </div>
            </Form>

            <div className="mt-5">
              <p className="mb-2">
                If you are an employer and your organisation doesnt already have an account with QJumpers, please email{" "}
                <strong>support@qjumpers.com</strong> for a registration link.
              </p>
              <p className="mb-4">
                If your organisation already has a QJumpers account please contact your HR Team for access.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <LoginFooter />
    </div>
  );
};

export default EmailEnter;
